import {Pipe, PipeTransform} from '@angular/core';
import {GenDataCenterOperationStatus} from '../../generated/serverModels/GenDataCenterOperationStatus';

@Pipe({
  name: 'datacenterOperationalStatus',
})
export class DatacenterOperationalStatusPipe implements PipeTransform {

  transform(value: GenDataCenterOperationStatus): string {
    switch (value) {
      case GenDataCenterOperationStatus.OPERATIONAL:
        return 'Operational';
      case GenDataCenterOperationStatus.CANCELED:
        return 'Canceled';
      case GenDataCenterOperationStatus.UNDER_CONSTRUCTION:
        return 'Under Construction';
      case GenDataCenterOperationStatus.LAND_HELD:
        return 'Land Held';
      case GenDataCenterOperationStatus.PLANNED:
        return 'Planned';
      default:
        console.error(`${value.toString()} is not a valid GenDataCenterOperationStatus`);
        return 'Not Available';
    }
  }

}
